module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon8.c835d064.svg";